// extracted by mini-css-extract-plugin
module.exports = {"form":"FormPost_form__LSZ04"};